var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMid meet",
    viewBox: "0 0 48 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "diners_club") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.00001915 C0,1.34315432 1.33389258,0 3.00261497,0 L44.997385,0 C46.6556835,0 48,1.34731857 48,3.00001915 L48,26.9999809 C48,28.6568457 46.6661074,30 44.997385,30 L3.00261497,30 C1.34431651,30 0,28.6526814 0,26.9999809 L0,3.00001915 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diners_club"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1-Copy-65"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C8",
    strokeWidth: 1,
    d: "M0.5,3.00001915 L0.5,26.9999809 C0.5,28.3779877 1.62190743,29.5 3.00261497,29.5 L44.997385,29.5 C46.3861928,29.5 47.5,28.3844807 47.5,26.9999809 L47.5,3.00001915 C47.5,1.62201227 46.3780926,0.5 44.997385,0.5 L3.00261497,0.5 C1.61380716,0.5 0.5,1.61551926 0.5,3.00001915 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-163",
    fill: "#0079BE",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-99",
    fill: "#0079BE",
    x: 8,
    y: 0,
    width: 4,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16 C16.418278,16 20,12.418278 20,8 C20,3.581722 16.418278,0 12,0 C7.581722,0 4,3.581722 4,8 C4,12.418278 7.581722,16 12,16 Z",
    id: "Oval-163-Copy",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-163-Copy-2",
    fill: "#FFFFFF",
    cx: 8,
    cy: 8,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-163-Copy-3",
    fill: "#0079BE",
    cx: 8,
    cy: 8,
    r: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-100",
    fill: "#FFFFFF",
    x: 7,
    y: 3,
    width: 2,
    height: 10
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/DinersClub.14d8b95cf2fa59306429b28971c19c82.svg";
export { ForwardRef as ReactComponent };